import { TranslateModule } from '@ngx-translate/core';
import { BadgeModule } from 'primeng/badge';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ListLoadStatus, tabBadgeFor } from '../../models/list-load-state';

/** A fül fejlécében: töltés közben helykitöltő, hibánál figyelmeztetés, betöltve a (szűrt) darabszám. */
@Component({
  selector: 'app-tab-load-badge',
  standalone: true,
  imports: [TranslateModule, BadgeModule, SkeletonModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @let current = badge();
    @switch (current.kind) {
      @case ('loading') {
        <span class="inline-flex items-center">
          <p-skeleton width="1.75rem" height="1.25rem" borderRadius="999px" />
          <span class="sr-only">{{ 'common.loading' | translate }}</span>
        </span>
      }
      @case ('error') {
        <i
          class="pi pi-exclamation-circle text-red-500 dark:text-red-400"
          role="img"
          [attr.aria-label]="'bookingOverview.loadError.tabTooltip' | translate"
          [pTooltip]="'bookingOverview.loadError.tabTooltip' | translate"
          tooltipPosition="top"
        ></i>
      }
      @case ('count') {
        @if (current.kind === 'count') {
          <p-badge [value]="current.value" [severity]="current.severity" />
        }
      }
    }
  `
})
export class TabLoadBadgeComponent {
  readonly status = input.required<ListLoadStatus>();
  readonly count = input.required<number>();

  protected readonly badge = computed(() => tabBadgeFor(this.status(), this.count()));
}
